export default __webpack_public_path__ + "static/studyoffice-circle-d34edd9ea00969d1a707c81d6e3c1c78.jpeg";